import React, { createRef, useEffect, useState } from "react";
import { RouteComponentProps } from "@reach/router";
import slugify from "slugify";
import ReactMarkdown from "react-markdown";

import PromotionDetails from "./details";

export { PromotionDetails };
